"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var action_row_styles_1 = require("./action-row.styles");

var ActionRow = function ActionRow(_ref) {
  var Icon = _ref.Icon,
      text = _ref.text;
  return React.createElement(action_row_styles_1.RowWrapperDiv, null, React.createElement(action_row_styles_1.ActionIconWrapperDiv, null, React.createElement(Icon, {
    fontSize: "large"
  })), React.createElement("span", null, text));
};

exports.default = ActionRow;